import { useEffect, useState } from 'react';
import { VoiceCallRecordingDto } from '@act/shared/data-transfer-objects';
import { Box, Typography } from '@mui/material';
import PostCallFeedback from './post-call-feedback/PostCallFeedback';
import { SparkleIcon } from '@phosphor-icons/react';
import { summaryFormatter } from 'utilities/formatters/SummaryFormatter';
import PaddedPane from './PaddedPane';
import { TrackingProvider } from 'react-components/tracking';

interface SummaryPaneProps {
  voiceCallRecording: VoiceCallRecordingDto;
}

const SummaryPane = ({ voiceCallRecording }: SummaryPaneProps) => {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(
    voiceCallRecording?.isAccurateSummary === null
  );

  useEffect(() => {
    if (voiceCallRecording?.isAccurateSummary === null) {
      setIsFeedbackOpen(true);
    }
  }, [voiceCallRecording?.isAccurateSummary]);

  if (!voiceCallRecording) {
    return null;
  }

  return (
    <TrackingProvider contextName="summary-pane">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
          padding: '0 4px',
        }}
      >
        <PaddedPane tinted flexible hasTopMargin>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
              paddingRight: 1,
              position: 'relative',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginBottom: 2,
              }}
            >
              <SparkleIcon size={16} />
              <Typography variant="bodySmall">Generated</Typography>
            </Box>
            {voiceCallRecording?.llmGeneratedNotes
              ? summaryFormatter.markdownDisplayer(
                  voiceCallRecording?.llmGeneratedNotes
                )
              : 'No generated notes available.'}
          </Box>
        </PaddedPane>

        {isFeedbackOpen && (
          <Box sx={{ flexShrink: 0 }}>
            <PostCallFeedback
              feedbackType="summary"
              voiceCallRecording={voiceCallRecording}
              onClose={() => setIsFeedbackOpen(false)}
            />
          </Box>
        )}
      </Box>
    </TrackingProvider>
  );
};

export default SummaryPane;
